import {
  Box,
  Grid,
  Typography,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import mixpanelTrack from "app/common/MixpanelComponent";
import { setFilters } from "app/filters/duck/slices";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ScaleLoader from "react-spinners/ScaleLoader";
import { primaryColor } from "resources/constants";
import ExplicabilityComponent from "app/explicability-info/ExplicabilityComponent";
import ScenariosComparatorComponent from "./ScenariosComparatorComponent";

const filtersInitialState = {
  category: undefined,
  line: undefined,
  // product: undefined,
  // brand: undefined,
  // retailer: undefined,
  // retailerGroup: undefined,
  // area: undefined,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: "1",
    minHeight: 0,
  },
  headerContainer: {
    display: "flex",
    borderBottom: "1px solid #e2e2e2",
    marginBottom: "10px",
    marginLeft: "10px",
    marginRight: "10px",
    flexWrap: "nowrap",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      paddingBottom: "10px",
    },
  },
  headerTitle: {
    paddingBottom: theme.spacing(1.5),
  },
  iconExportContainer: {
    display: "flex",
    paddingBottom: "10px",
  },
  spinnerContainer: {
    display: "flex",
    flexGrow: "1",
    alignItems: "center",
    justifyContent: "center",
  },
  halfHeight: theme.halfHeight,
  componentContainer: {
    maxHeight: "100%",
  },
}));

function CompetitorsComponent() {
  const classes = useStyles();
  const dataloadSlice = useSelector((state) => state.dataload);
  const dispatch = useDispatch();
  // In case we need the cache restoration
  // const filtersSlice = useSelector((state) => state.filters.filters);
  // const [filtersPrevState, setFiltersPrevState] = useState({});
  // const filtersPrevRef = React.useRef(filtersPrevState);

  const StyledTypography = withStyles(() => ({
    root: {
      flex: 1,
      direction: "ltr",
      flexDirection: "row-reverse",
    },
  }))(Typography);

  React.useEffect(() => {
    /* MIXPANEL TRACKS */
    mixpanelTrack("Competitors 2.0 module visited");
    /* END OF MIXPANEL TRACKS */
    // In case we need the cache restoration
    // setFiltersPrevState(filtersSlice);
    dispatch(setFilters(filtersInitialState));

    return () => {
      dispatch(setFilters(filtersInitialState));
      // In case we need the cache restoration
      // dispatch(setFilters(filtersPrevRef.current));
    };
  }, []);

  // In case we need the cache restoration
  // React.useEffect(() => {
  //   filtersPrevRef.current = filtersPrevState;
  // }, [filtersPrevState]);

  return (
    <>
      {dataloadSlice.selectedDataload.id ? (
        <>
          <Box className={classes.headerContainer}>
            <StyledTypography variant="h6" className={classes.headerTitle}>
              Competitor Scenarios
              <ExplicabilityComponent tooltipText="Predictive market share is the main indicator for measuring your potential business impact in the categories in which you compete with others. This module allows you to simulate What if scenarios to optimize your TPo strategy. " />
            </StyledTypography>
          </Box>
          <Grid container className={classes.root}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.componentContainer}
            >
              <ScenariosComparatorComponent />
            </Grid>
          </Grid>
        </>
      ) : (
        <Box component="div" className={classes.spinnerContainer}>
          <ScaleLoader size={150} color={primaryColor} loading />
        </Box>
      )}
    </>
  );
}

export default CompetitorsComponent;
